import { IMMIGRANT_SURNAMES } from '../utils/NameData';

/**
 * 人口制御システム定数
 * パラメータ調整はここで一元管理
 */

// 移住者苗字を再エクスポート（後方互換性のため）
export { IMMIGRANT_SURNAMES };

export const POPULATION_CONSTANTS = {
  // === 年齢システム ===
  ADULT_AGE: 18, // 成人年齢（パートナー形成・出生可能）
  LIFESPAN_MIN: 70, // 最短寿命
  LIFESPAN_MAX: 100, // 最長寿命

  // === 出生制御 ===
  BIRTH_BASE_RATE: 0.08, // 基本出生率（8%/日/カップル）
  BIRTH_MAX_CHILDREN: 3, // 1人あたりの最大子供数

  // === パートナー選択 ===
  PARTNER_MIN_AFFECTION: 30, // パートナー形成に必要な最低好感度
  PARTNER_STRENGTH_WEIGHT: 0.3, // 強さへの憧れ係数（勝率×この値）
  PARTNER_SIMILARITY_WEIGHT: 0.5, // 同レベル婚係数（勝率差×この値で減点）
  PARTNER_MIN_BATTLES: 5, // マッチスコア計算に必要な最低戦闘数

  // === 密度ペナルティ ===
  MAX_POPULATION_RATIO: 0.8, // マップタイル数の80%が人口上限

  // === 強者生存 ===
  MIN_BATTLES_FOR_RATE: 5, // 勝率計算に必要な最低戦闘数

  // === デュエル淘汰 ===
  CULL_MIN_BATTLES: 10, // 淘汰判定に必要な最低戦闘数
  CULL_WIN_RATE_THRESHOLD: 0.1, // 淘汰される勝率閾値（10%未満）
  CULL_CHECK_INTERVAL: 7, // 淘汰チェック間隔（日）

  // === 移住システム ===
  IMMIGRATION_INTERVAL: 30, // 移住イベント間隔（日）
  IMMIGRATION_BASE_COUNT: 2, // 基本移住者数
  IMMIGRATION_POPULATION_FACTOR: 0.02, // 人口に対する追加移住率（2%）
};
